<template>
  <div class="sign-entry">
    <div v-if="showAgreement" class="agreement-overlay">
      <div class="agreement-card">
        <div class="agreement-card__badge">电子签署</div>
        <h3 class="agreement-card__title">签署须知</h3>
        <div class="agreement-card__body">
          <p>请仔细阅读合同内容，确认后使用姓名生成的文字签名提交。</p>
          <ul>
            <li>签名由真实姓名自动生成，提交后具有法律效力</li>
            <li>请确认签名落在提示框内</li>
            <li>提交成功后将自动返回</li>
          </ul>
        </div>
        <label class="agreement-card__check">
          <span class="agreement-card__checkbox" :class="{ on: agreed }">
            <i v-if="agreed" class="el-icon-check"></i>
          </span>
          <input v-model="agreed" type="checkbox" />
          <span>我已阅读并同意以上内容</span>
        </label>
        <button
          class="agreement-card__btn"
          :disabled="!canStart || !agreed"
          @click="startSign"
        >
          {{ canStart ? '开始签署' : `请阅读 (${countdown}s)` }}
        </button>
        <p v-if="loadError" class="agreement-card__error">{{ loadError }}</p>
      </div>
    </div>
    <Signature-vue ref="SignatureForm" />
  </div>
</template>

<script>
import {
  parseSignQuery,
  fetchContractDetail,
  formatFileUrl,
} from '../utils/signApi'

export default {
  name: 'HelloWorld',
  data() {
    return {
      showAgreement: true,
      countdown: 3,
      canStart: false,
      agreed: false,
      loadError: '',
      query: {
        contractId: '',
        token: '',
        api: '',
      },
    }
  },
  mounted() {
    this.query = parseSignQuery()
    if (!this.query.contractId || !this.query.token || !this.query.api) {
      this.loadError = '链接参数不完整，请从骑手端重新进入'
    }
    this.startCountdown()
  },
  methods: {
    startCountdown() {
      this.countdown = 3
      this.canStart = false
      const timer = setInterval(() => {
        this.countdown -= 1
        if (this.countdown <= 0) {
          this.canStart = true
          clearInterval(timer)
        }
      }, 1000)
    },
    async startSign() {
      if (!this.agreed || !this.canStart) return
      const { contractId, token, api } = this.query
      if (!contractId || !token || !api) {
        this.$message.error('缺少合同参数，请重新打开')
        return
      }

      this.loadError = ''
      try {
        const contract = await fetchContractDetail(api, contractId, token)
        this.showAgreement = false
        this.$nextTick(() => {
          this.$refs.SignatureForm.init({
            pdfUrl: formatFileUrl(api, contract.pdf_url),
            token,
            contractId: contract.id,
            api,
            sealUrl: contract.seal_url || '',
            signPositions: contract.sign_positions || [],
            signerName: contract.signer_name || '',
          })
        })
      } catch (e) {
        console.error(e)
        this.loadError = e.message || '加载合同失败'
        this.$message.error(this.loadError)
      }
    },
  },
}
</script>

<style scoped>
.sign-entry {
  width: 100vw;
  height: 100vh;
  background: #f3f4f6;
}

.agreement-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(17, 24, 39, 0.48);
  backdrop-filter: blur(2px);
}

.agreement-card {
  width: 100%;
  max-width: 340px;
  padding: 22px 20px 20px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.16);
}

.agreement-card__badge {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 500;
  color: #e4572e;
  background: #fff5f1;
  border-radius: 12px;
}

.agreement-card__title {
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 650;
  color: #1f2329;
  letter-spacing: 0.5px;
}

.agreement-card__body {
  padding: 12px 14px;
  font-size: 13px;
  line-height: 1.65;
  color: #5c6570;
  background: #f7f8fa;
  border-radius: 10px;
}

.agreement-card__body p {
  margin: 0 0 8px;
  color: #30353c;
}

.agreement-card__body ul {
  margin: 0;
  padding-left: 18px;
}

.agreement-card__body li {
  margin-bottom: 4px;
}

.agreement-card__check {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 16px 0 14px;
  font-size: 13px;
  color: #4b5563;
  cursor: pointer;
}

.agreement-card__check input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.agreement-card__checkbox {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 1.5px solid #c9ced6;
  border-radius: 4px;
  background: #fff;
  color: #fff;
  font-size: 12px;
}

.agreement-card__checkbox.on {
  border-color: #e4572e;
  background: #e4572e;
}

.agreement-card__btn {
  width: 100%;
  height: 46px;
  border: none;
  border-radius: 23px;
  background: linear-gradient(135deg, #f06a45 0%, #e4572e 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 560;
  letter-spacing: 0.5px;
  box-shadow: 0 8px 18px rgba(228, 87, 46, 0.28);
}

.agreement-card__btn:disabled {
  background: #d7dbe2;
  box-shadow: none;
}

.agreement-card__error {
  margin: 10px 0 0;
  font-size: 12px;
  color: #f05656;
  text-align: center;
}
</style>
